import { IMPORTANT_CONTACT_ROLES } from 'clickNgo/entities/contact'

export const getImportantRolesToReassign = (roles: string[]) => {
  return roles.filter((role) => IMPORTANT_CONTACT_ROLES.includes(role)).map((role) => ({ role }))
}
